<script lang="ts">
    import Cta from "../../../components/CTA.svelte"
    import Modal from "../../../components/Modal.svelte"
    import { apiBaseURL } from "../../../../config"
    import { createEventDispatcher } from "svelte"
    import ImageMetaData from "./ImageMetaData.svelte"
    import UploadImage from "./UploadImage.svelte"
    import { downloadSelectedImages } from "../helper"
    import { onChange } from "../../../components/formComponents/helper"
    import Input from "../../../components/formComponents/Input.svelte"
    import { putDBEntry } from "../../../../api"
    const dispatch = createEventDispatcher()
    export let images: Media[] = []
</script>

<Modal
    show="{true}"
    size="xl"
    on:close="{() => {
        dispatch('closeImageLibrary')
    }}"
>
    <h3
        class="label"
        slot="header"
    >
        <img
            src="../../../assets/icons/solar_camera-outline.svg"
            alt="icon"
        />
        <p>FOTOS</p>
    </h3>
    <div class="images">
        <UploadImage on:uploadImage="{() => dispatch('uploadImage')}" />
        {#each images as image}
            <div class="image">
                <div class="image-wrapper">
                    <img
                        src="{`${apiBaseURL}media/${image.id}/${image.file.src}`}"
                        alt="Image Preview"
                        class="image"
                        aria-hidden="true"
                    />
                    <button
                        class="removeElement"
                        on:click="{() => {
                            dispatch('removeImage', image.id)
                        }}"
                    >
                        <img
                            src="../../../assets/icons/solar_close-circle-outline-white.svg"
                            alt="icon"
                        />
                    </button>
                </div>
                <ImageMetaData bind:image="{image}" />
                <Input
                    placeholder="Kommentar"
                    bind:value="{image.comment}"
                    onChange="{onChange}"
                    onBlur="{() => {
                        putDBEntry('media', { id: image.id, comment: image.comment })
                    }}"
                    id="comment"
                    type="textarea"
                    smallTextarea="{true}"
                />
            </div>
        {/each}
    </div>
    <div slot="footer">
        <Cta
            type="ghostButtonReverse"
            content="Alle Einsatzbilder"
            icon="solar_album-outline"
            on:click="{(e) => {
                e.stopPropagation()
                e.preventDefault()
                //@ts-ignore
                downloadSelectedImages(images, images)
            }}"
        />
    </div>
</Modal>

<style lang="less">
    @import "../../../../../assets/variables.less";
    h3.label {
        display: flex;
        gap: 0.6rem;
        align-items: center;
    }
    .images {
        display: grid;
        grid-template-columns: repeat(auto-fill, 12rem);
        gap: 6px;

        .image {
            width: 12rem;
            display: flex;
            flex-direction: column;

            .image-wrapper {
                height: 12rem;
                width: 100%;
                position: relative;

                background-color: var(--text-100);
                width: 100%;
                aspect-ratio: 1/1;

                img {
                    width: 100%;
                    height: unset;
                    aspect-ratio: 1/1;
                    object-fit: cover;
                    border-radius: 12px;
                }
                @media @mobile {
                    width: min(200px, 40vw);
                    min-width: 50%;
                    height: 50%;
                    aspect-ratio: unset;
                    img {
                        aspect-ratio: unset;
                        height: 100%;
                    }
                }
                position: relative;
                .removeElement {
                    top: 0.6rem;
                    right: 0.6rem;
                    position: absolute;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 1.6rem;
                    height: 1.6rem;
                    border-radius: 48px;
                    background: var(--text-100);
                    img {
                        width: 1.2rem;
                        height: 1.2rem;
                    }
                }
                border-radius: 12px;
                img {
                    width: 100%;
                    border-radius: 12px;
                    height: 100%;
                    object-fit: cover;
                }
            }
            @media @mobile {
                flex-direction: row;
                gap: 6px;
                width: 100%;
            }
        }
        @media @mobile {
            display: flex;
            flex-direction: column;
            width: 100%;
        }
    }
</style>
